/* Print Finish picker (lightbox): show nothing as selected until the customer has actually chosen a finish.
   The picker keeps a built-in default (Classic Frame / Black) which it highlights even when the real Print Finish
   field is still empty. This hides that highlight and disables the next button until a real choice is made.
   Also removes the pink "Most popular: Classic Frame" tab above the Print Finish dropdown, the
   "Most popular" tag inside the picker, and the separate "Glazing" tab (glazing is shown on each frame row
   as "Print protection"). */
(function () {
  if (window.__fpFinishNone) return;
  window.__fpFinishNone = 1;

  var st = document.createElement('style');
  st.textContent = '.fp-go:disabled{opacity:.45;cursor:default}.fp-go:disabled:hover{background:#ff0a89}' +
    '.gpo-box-frame-field.gpo-has-classic .gpo-select::before{display:none !important;content:none !important}' +
    '.gpo-box-frame-field.gpo-has-classic .gpo-select select{border-radius:6px !important}' +
    '.fp-lb .fp-rec{display:none !important}' +
    '.fp-lb .fp-tab[data-tab="glazing"],.fc-tab[data-tab="glazing"]{display:none !important}';
  document.head.appendChild(st);

  var PROT = {
    'Clear acrylic glazing': 'Clear acrylic glass, shatter-resistant',
    'No glazing': 'Not needed for canvas',
    'None (unframed)': 'Not included (unframed)'
  };

  function relabel(dlg) {
    var dts = dlg.querySelectorAll('.fp-detail dt');
    for (var i = 0; i < dts.length; i++) {
      var dt = dts[i];
      if (/^\s*Protection:\s*$/.test(dt.textContent)) {
        dt.textContent = 'Print protection: ';
      }
      if (/^\s*Print protection:\s*$/.test(dt.textContent)) {
        var dd = dt.nextElementSibling;
        if (dd) {
          var t = dd.textContent.trim();
          if (PROT[t]) dd.textContent = PROT[t];
        }
      }
    }
  }

  function shown(e) {
    return !!(e && (e.offsetParent !== null || e.getClientRects().length));
  }

  function finishSelect() {
    var list = document.querySelectorAll('.gpo-element select, .gpo-select select');
    for (var i = 0; i < list.length; i++) {
      var s = list[i];
      var n = s.name || s.getAttribute('data-field-name') || '';
      var isFinish = /print finish/i.test(n) || (/^select-\d+$/.test(n) && s.querySelector('option[value="Unframed/Fine Art Print"]'));
      if (isFinish && shown(s)) return s;
    }
    return null;
  }

  function nothingChosen() {
    var s = finishSelect();
    return !!s && !s.value;
  }

  function apply() {
    var dlg = document.querySelector('dialog.fp-lb');
    if (!dlg) return;
    relabel(dlg);
    if (!dlg.open) return;
    var go = dlg.querySelector('#fp-go');
    if (nothingChosen()) {
      var opts = dlg.querySelectorAll('#fp-panel .fp-opt[data-pick]');
      for (var i = 0; i < opts.length; i++) {
        var b = opts[i];
        if (b.classList.contains('is-selected')) b.classList.remove('is-selected');
        if (b.getAttribute('aria-pressed') !== 'false') b.setAttribute('aria-pressed', 'false');
      }
      if (go) {
        if (!go.disabled) go.disabled = true;
        var sp = go.querySelector('span');
        if (sp && sp.textContent !== 'Choose an option') sp.textContent = 'Choose an option';
      }
    } else if (go && go.disabled && !go.hasAttribute('data-mneed')) {
      go.disabled = false;
    }
  }

  function hook() {
    var d = document.querySelector('dialog.fp-lb');
    if (d && !d.__fpNone) {
      d.__fpNone = 1;
      new MutationObserver(apply).observe(d, { childList: true, subtree: true });
    }
    apply();
  }

  new MutationObserver(hook).observe(document.body, { childList: true });
  hook();

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.fc-btn, .fc-help, .fp-cover')) {
      [80, 250, 700].forEach(function (ms) { setTimeout(hook, ms); });
    }
  }, true);
})();

/* Tidier order below Add to cart: loads fp-order.js (compact trust line, details above reviews). The version tag changes every 10 minutes so edits show up quickly. */
(function () {
  try {
    var me = document.querySelector('script[src*="fp-finish-none.js"]');
    if (!me || window.__fpOrderLoaded) return;
    window.__fpOrderLoaded = 1;
    var s = document.createElement('script');
    s.src = me.src.replace(/fp-finish-none\.js.*$/, 'fp-order.js') + '?v=' + Math.floor(Date.now() / 600000);
    document.head.appendChild(s);
  } catch (e) { /* never break the page */ }
})();
